import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ApiClientService } from '../../services/api-client.service';

@Injectable()
export class EventsService extends ApiClientService {
  urlPath: string = `/recently_played`;

  constructor(api: ApiService) {
    super(api);
  }
}
